<div class="container">
  <div class="row">
    <app-forgot-password></app-forgot-password>
  </div>
</div>

<app-notifications></app-notifications>
